import {
  FilterPrice as FilterPriceUI,
  type FilterPriceComponentProps,
} from "@b2bportal/core-ui";
import { Currency } from "@hopper-b2b/types";

const fallbackCurrency = {
  currencyCode: Currency.CAD,
  currencySymbol: "CA$",
};

const maximumPriceFallback = {
  value: 1000,
  ...fallbackCurrency,
};

const minimumPriceFallback = {
  value: 0,
  ...fallbackCurrency,
};

export const FilterPrice = ({
  minimumPrice = minimumPriceFallback,
  maximumPrice = maximumPriceFallback,
  ...props
}: FilterPriceComponentProps) => {
  return (
    <FilterPriceUI
      minimumPrice={minimumPrice}
      maximumPrice={maximumPrice}
      {...props}
    />
  );
};
